<template>
  <div class="breadcrumb-block">
      <Breadcrumb :model="getBreadcrumbs">
          <template #item="{item}">
              <a class="breadcrumb-link" :href="item.href">
                  {{ item.label }}
              </a>
          </template>
      </Breadcrumb>
  </div>
</template>

<script>
import { useBreadcrumbStore } from "./stores/breadcrumb.js";
import { mapState} from "pinia";
export default {
  computed: {
    ...mapState(useBreadcrumbStore, ["getBreadcrumbs"])
  }
};
</script>

<style></style>
